import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'address-edit',
  templateUrl: './address-edit.component.html',
  styleUrls: ['./address-edit.component.scss']
})
export class AddressEditComponent implements OnInit {
  summaryPanel;
  get summaryAPIData() {
    return this.summaryPanel;
  }
  @Input() set summaryAPIData(value) {
    this.summaryPanel = { ...value };
  }
  @Input() summarySitecoreData;
  @Input() pageName;

  constructor() {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
